const { createReducer } = require('../helpers')
const {
  GET_ADMIN_CONSULTATIONS_LIST,
  GET_ADMIN_CONSULTATIONS_LIST_SUCCESS,
  GET_ADMIN_CONSULTATIONS_LIST_ERROR,
  GET_ADMIN_CONSULTATIONS_LIST_RESET,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_SUCCESS,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_ERROR,
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_RESET,
  GET_ADMIN_CONSULTATION,
  GET_ADMIN_CONSULTATION_SUCCESS,
  GET_ADMIN_CONSULTATION_ERROR,
  GET_ADMIN_CONSULTATION_RESET,
  CREATE_ADMIN_CONSULTATION,
  CREATE_ADMIN_CONSULTATION_SUCCESS,
  CREATE_ADMIN_CONSULTATION_ERROR,
  CREATE_ADMIN_CONSULTATION_RESET,
  UPDATE_ADMIN_CONSULTATION,
  UPDATE_ADMIN_CONSULTATION_SUCCESS,
  UPDATE_ADMIN_CONSULTATION_ERROR,
  UPDATE_ADMIN_CONSULTATION_RESET,
  DELETE_ADMIN_CONSULTATION,
  DELETE_ADMIN_CONSULTATION_SUCCESS,
  DELETE_ADMIN_CONSULTATION_ERROR,
  DELETE_ADMIN_CONSULTATION_RESET,
  UPDATE_STATUS_ADMIN_CONSULTATION,
  UPDATE_STATUS_ADMIN_CONSULTATION_SUCCESS,
  UPDATE_STATUS_ADMIN_CONSULTATION_ERROR,
  UPDATE_STATUS_ADMIN_CONSULTATION_RESET,

  GET_CONSULTATIONS_LIST,
  GET_CONSULTATIONS_LIST_ERROR,
  GET_CONSULTATIONS_LIST_RESET,
  GET_CONSULTATIONS_LIST_SUCCESS,
  GET_AVAILABLE_CONSULTATIONS_LIST,
  GET_AVAILABLE_CONSULTATIONS_LIST_SUCCESS,
  GET_AVAILABLE_CONSULTATIONS_LIST_ERROR,
  GET_AVAILABLE_CONSULTATIONS_LIST_RESET,
  CREATE_CONSULTATION,
  CREATE_CONSULTATION_ERROR,
  CREATE_CONSULTATION_RESET,
  CREATE_CONSULTATION_SUCCESS,
  GET_CONSULTATION_HISTORY_LIST,
  GET_CONSULTATION_HISTORY_LIST_SUCCESS,
  GET_CONSULTATION_HISTORY_LIST_ERROR,
  GET_CONSULTATION_HISTORY_LIST_RESET,
  GET_CONSULTATION_HISTORY_DETAILS,
  GET_CONSULTATION_HISTORY_SUCCESS,
  GET_CONSULTATION_HISTORY_ERROR,
  GET_CONSULTATION_HISTORY_RESET,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_SUCCESS,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_ERROR,
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_RESET,
  GET_DOCTOR_CONSULTATION_OVERVIEW,
  GET_DOCTOR_CONSULTATION_OVERVIEW_SUCCESS,
  GET_DOCTOR_CONSULTATION_OVERVIEW_ERROR,
  GET_DOCTOR_CONSULTATION_OVERVIEW_RESET,
  ASSIGN_DOC_TO_CONSULTATION,
  ASSIGN_DOC_TO_CONSULTATION_SUCCESS,
  ASSIGN_DOC_TO_CONSULTATION_ERROR,
  ASSIGN_DOC_TO_CONSULTATION_RESET,
  SET_CONSULTATION_PREFERENCE,
  SET_CONSULTATION_PREFERENCE_SUCCESS,
  SET_CONSULTATION_PREFERENCE_ERROR,
  SET_CONSULTATION_PREFERENCE_RESET,
  GET_PATIENT_RECORD,
  GET_PATIENT_RECORD_SUCCESS,
  GET_PATIENT_RECORD_ERROR,
  GET_PATIENT_RECORD_RESET,
  POST_DOCTOR_NOTES,
  POST_DOCTOR_NOTES_SUCCESS,
  POST_DOCTOR_NOTES_ERROR,
  POST_DOCTOR_NOTES_RESET,
  POST_DOCTOR_MC,
  POST_DOCTOR_MC_SUCCESS,
  POST_DOCTOR_MC_ERROR,
  POST_DOCTOR_MC_RESET,
  POST_DOCTOR_REFERRAL,
  POST_DOCTOR_REFERRAL_SUCCESS,
  POST_DOCTOR_REFERRAL_ERROR,
  POST_DOCTOR_REFERRAL_RESET,
  END_DOCTOR_CONSULTATION,
  END_DOCTOR_CONSULTATION_SUCCESS,
  END_DOCTOR_CONSULTATION_ERROR,
  END_DOCTOR_CONSULTATION_RESET,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_SUCCESS,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_ERROR,
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_RESET,
  GET_DOCTOR_TWILIO_TOKEN,
  GET_DOCTOR_TWILIO_TOKEN_SUCCESS,
  GET_DOCTOR_TWILIO_TOKEN_ERROR,
  GET_DOCTOR_TWILIO_TOKEN_RESET,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_SUCCESS,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_ERROR,
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_RESET,
  GET_MD_REFERRAL_NEW_LINK,
  GET_MD_REFERRAL_NEW_LINK_SUCCESS,
  GET_MD_REFERRAL_NEW_LINK_ERROR,
  GET_MD_REFERRAL_NEW_LINK_RESET,
  GET_MD_MC_NEW_LINK,
  GET_MD_MC_NEW_LINK_SUCCESS,
  GET_MD_MC_NEW_LINK_ERROR,
  GET_MD_MC_NEW_LINK_RESET,
  CHECK_PATIENT_CONSULTATION_STATUS,
  CHECK_PATIENT_CONSULTATION_STATUS_SUCCESS,
  CHECK_PATIENT_CONSULTATION_STATUS_ERROR,
  CHECK_PATIENT_CONSULTATION_STATUS_RESET,
  VERIFY_TRANSACTION_AMOUNT,
  VERIFY_TRANSACTION_AMOUNT_SUCCESS,
  VERIFY_TRANSACTION_AMOUNT_ERROR,
  VERIFY_TRANSACTION_AMOUNT_RESET,
  GET_PRESCRIPTION_ID,
  GET_PRESCRIPTION_ID_SUCCESS,
  GET_PRESCRIPTION_ID_ERROR,
  GET_PRESCRIPTION_ID_RESET,
  POST_REGENERATE_AGORA_TOKEN,
  POST_REGENERATE_AGORA_TOKEN_SUCCESS,
  POST_REGENERATE_AGORA_TOKEN_ERROR,
  POST_REGENERATE_AGORA_TOKEN_RESET,
} = require('./constants')

const initialState = {
  adminConsultationsList: {
    data: null,
    loading: false,
    error: null,
  },
  sendAdminConsultationsCSVEmail: {
    data: null,
    loading: false,
    error: null,
  },
  adminConsultation: {
    data: null,
    loading: false,
    error: null,
  },
  createAdminConsultation: {
    data: null,
    loading: false,
    error: null,
  },
  updateAdminConsultation: {
    data: null,
    loading: false,
    error: null,
  },
  deleteAdminConsultation: {
    data: null,
    loading: false,
    error: null,
  },
  updateStatusAdminConsultation: {
    data: null,
    loading: false,
    error: null,
  },
  getMdReferralNewLinkAdmin: {
    data: null,
    loading: false,
    error: null,
  },
  getMdReferralNewLinkAppendAdmin: {
    data: [],
    loading: false,
    error: null,
  },
  getMdMCNewLinkAdmin: {
    data: null,
    loading: false,
    error: null,
  },
  getMdMCNewLinkAppendAdmin: {
    data: [],
    loading: false,
    error: null,
  },
  consultationList: {
    data: null,
    loading: false,
    error: null,
  },
  availableConsultationsList: {
    data: null,
    loading: false,
    error: null,
  },
  createConsultation: {
    data: null,
    loading: false,
    error: null,
  },
  consultationHistoryList: {
    data: null,
    loading: false,
    error: null,
  },
  consultationHistoryDetails: {
    data: null,
    loading: false,
    error: null,
  },
  doctorConsultationHistoryList: {
    data: null,
    loading: false,
    error: null,
  },
  doctorConsultationOverview: {
    data: null,
    loading: false,
    error: null,
  },
  assignDocToConsultation: {
    data: null,
    loading: false,
    error: null,
  },
  setConsultationPreference: {
    data: null,
    loading: false,
    error: null,
  },
  patientConsultationRecord: {
    data: null,
    loading: false,
    error: null,
  },
  postDoctorNotesState: {
    data: null,
    loading: false,
    error: null,
  },
  postDoctorMCState: {
    data: null,
    loading: false,
    error: null,
  },
  postDoctorReferralState: {
    data: null,
    loading: false,
    error: null,
  },
  endDoctorConsultationState: {
    data: null,
    loading: false,
    error: null,
  },
  sendAudioCallRequestByDoctorState: {
    data: null,
    loading: false,
    error: null,
  },
  getDoctorTwilioTokenState: {
    data: null,
    loading: false,
    error: null,
  },
  postConsultationTimeLapsedState: {
    data: null,
    loading: false,
    error: null,
  },
  getMDReferralNewLinkState: {
    data: null,
    loading: false,
    error: null,
  },
  getMDMcNewLinkState: {
    data: null,
    loading: false,
    error: null,
  },
  checkPatientConsultationStatusState: {
    data: null,
    loading: false,
    error: null,
  },
  verifyTransactionAmountState: {
    data: null,
    loading: false,
    error: null,
  },
  getPrescriptionIdState: {
    data: null,
    loading: false,
    error: null,
  },
  postRegenerateAgoraTokenState: {
    data: null,
    loading: false,
    error: null,
  },
}

module.exports = createReducer({
  [GET_ADMIN_CONSULTATIONS_LIST]: draft => ({
    adminConsultationsList: {
      ...draft.adminConsultationsList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_ADMIN_CONSULTATIONS_LIST_SUCCESS]: (draft, action) => ({
    adminConsultationsList: {
      ...draft.adminConsultationsList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_ADMIN_CONSULTATIONS_LIST_ERROR]: (draft, action) => ({
    adminConsultationsList: {
      ...draft.adminConsultationsList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_ADMIN_CONSULTATIONS_LIST_RESET]: () => ({
    adminConsultationsList: { ...initialState.adminConsultationsList },
  }),

  [SEND_ADMIN_CONSULTATIONS_CSV_EMAIL]: draft => ({
    sendAdminConsultationsCSVEmail: {
      ...draft.sendAdminConsultationsCSVEmail,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_SUCCESS]: (draft, action) => ({
    sendAdminConsultationsCSVEmail: {
      ...draft.sendAdminConsultationsCSVEmail,
      loading: false,
      data: action.payload.data,
    },
  }),
  [SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_ERROR]: (draft, action) => ({
    sendAdminConsultationsCSVEmail: {
      ...draft.sendAdminConsultationsCSVEmail,
      loading: false,
      error: action.payload.error,
    },
  }),
  [SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_RESET]: () => ({
    sendAdminConsultationsCSVEmail: { ...initialState.sendAdminConsultationsCSVEmail },
  }),

  [GET_ADMIN_CONSULTATION]: draft => ({
    adminConsultation: {
      ...draft.adminConsultation,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_ADMIN_CONSULTATION_SUCCESS]: (draft, action) => ({
    adminConsultation: {
      ...draft.adminConsultation,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_ADMIN_CONSULTATION_ERROR]: (draft, action) => ({
    adminConsultation: {
      ...draft.adminConsultation,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_ADMIN_CONSULTATION_RESET]: () => ({
    adminConsultation: { ...initialState.adminConsultation },
  }),

  [CREATE_ADMIN_CONSULTATION]: draft => ({
    createAdminConsultation: {
      ...draft.createAdminConsultation,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [CREATE_ADMIN_CONSULTATION_SUCCESS]: (draft, action) => ({
    createAdminConsultation: {
      ...draft.createAdminConsultation,
      loading: false,
      data: action.payload.data,
    },
  }),
  [CREATE_ADMIN_CONSULTATION_ERROR]: (draft, action) => ({
    createAdminConsultation: {
      ...draft.createAdminConsultation,
      loading: false,
      error: action.payload.error,
    },
  }),
  [CREATE_ADMIN_CONSULTATION_RESET]: () => ({
    createAdminConsultation: { ...initialState.createAdminConsultation },
  }),

  [UPDATE_ADMIN_CONSULTATION]: draft => ({
    updateAdminConsultation: {
      ...draft.updateAdminConsultation,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPDATE_ADMIN_CONSULTATION_SUCCESS]: (draft, action) => ({
    updateAdminConsultation: {
      ...draft.updateAdminConsultation,
      loading: false,
      data: action.payload.data,
    },
  }),
  [UPDATE_ADMIN_CONSULTATION_ERROR]: (draft, action) => ({
    updateAdminConsultation: {
      ...draft.updateAdminConsultation,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPDATE_ADMIN_CONSULTATION_RESET]: () => ({
    updateAdminConsultation: { ...initialState.updateAdminConsultation },
  }),

  [DELETE_ADMIN_CONSULTATION]: draft => ({
    deleteAdminConsultation: {
      ...draft.deleteAdminConsultation,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [DELETE_ADMIN_CONSULTATION_SUCCESS]: (draft, action) => ({
    deleteAdminConsultation: {
      ...draft.deleteAdminConsultation,
      loading: false,
      data: action.payload.data,
    },
  }),
  [DELETE_ADMIN_CONSULTATION_ERROR]: (draft, action) => ({
    deleteAdminConsultation: {
      ...draft.deleteAdminConsultation,
      loading: false,
      error: action.payload.error,
    },
  }),
  [DELETE_ADMIN_CONSULTATION_RESET]: () => ({
    deleteAdminConsultation: { ...initialState.deleteAdminConsultation },
  }),

  [UPDATE_STATUS_ADMIN_CONSULTATION]: draft => ({
    updateStatusAdminConsultation: {
      ...draft.updateStatusAdminConsultation,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPDATE_STATUS_ADMIN_CONSULTATION_SUCCESS]: (draft, action) => ({
    updateStatusAdminConsultation: {
      ...draft.updateStatusAdminConsultation,
      loading: false,
      data: action.payload.data,
    },
  }),
  [UPDATE_STATUS_ADMIN_CONSULTATION_ERROR]: (draft, action) => ({
    updateStatusAdminConsultation: {
      ...draft.updateStatusAdminConsultation,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPDATE_STATUS_ADMIN_CONSULTATION_RESET]: () => ({
    updateStatusAdminConsultation: { ...initialState.updateStatusAdminConsultation },
  }),

  [GET_CONSULTATIONS_LIST]: draft => ({
    consultationList: {
      ...draft.consultationList,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [GET_CONSULTATIONS_LIST_SUCCESS]: (draft, action) => ({
    consultationList: {
      ...draft.consultationList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_CONSULTATIONS_LIST_ERROR]: (draft, action) => ({
    consultationList: {
      ...draft.consultationList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_CONSULTATIONS_LIST_RESET]: () => ({
    consultationList: { ...initialState.consultationList },
  }),

  [GET_AVAILABLE_CONSULTATIONS_LIST]: draft => ({
    availableConsultationsList: {
      ...draft.availableConsultationsList,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [GET_AVAILABLE_CONSULTATIONS_LIST_SUCCESS]: (draft, action) => ({
    availableConsultationsList: {
      ...draft.availableConsultationsList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_AVAILABLE_CONSULTATIONS_LIST_ERROR]: (draft, action) => ({
    availableConsultationsList: {
      ...draft.availableConsultationsList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_AVAILABLE_CONSULTATIONS_LIST_RESET]: () => ({
    availableConsultationsList: { ...initialState.availableConsultationsList },
  }),

  [CREATE_CONSULTATION]: draft => ({
    createConsultation: {
      ...draft.createConsultation,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [CREATE_CONSULTATION_SUCCESS]: (draft, action) => ({
    createConsultation: {
      ...draft.createConsultation,
      loading: false,
      data: action.payload.data,
    },
  }),
  [CREATE_CONSULTATION_ERROR]: (draft, action) => ({
    createConsultation: {
      ...draft.createConsultation,
      loading: false,
      error: action.payload.error,
    },
  }),
  [CREATE_CONSULTATION_RESET]: () => ({
    createConsultation: { ...initialState.createConsultation },
  }),
  [GET_CONSULTATION_HISTORY_LIST]: draft => ({
    consultationHistoryList: {
      ...draft.consultationHistoryList,
      loading: true,
      error: null,
      data: null,
    },
  }),
  [GET_CONSULTATION_HISTORY_LIST_SUCCESS]: (draft, action) => ({
    consultationHistoryList: {
      ...draft.consultationHistoryList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_CONSULTATION_HISTORY_LIST_ERROR]: (draft, action) => ({
    consultationHistoryList: {
      ...draft.consultationHistoryList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_CONSULTATION_HISTORY_LIST_RESET]: () => ({
    consultationHistoryList: { ...initialState.consultationHistoryList },
  }),

  [GET_CONSULTATION_HISTORY_DETAILS]: draft => ({
    consultationHistoryDetails: {
      ...draft.consultationHistoryDetails,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_CONSULTATION_HISTORY_SUCCESS]: (draft, action) => ({
    consultationHistoryDetails: {
      ...draft.consultationHistoryDetails,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_CONSULTATION_HISTORY_ERROR]: (draft, action) => ({
    consultationHistoryDetails: {
      ...draft.consultationHistoryDetails,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_CONSULTATION_HISTORY_RESET]: () => ({
    consultationHistoryDetails: { ...initialState.consultationHistoryDetails },
  }),

  [GET_DOCTOR_CONSULTATION_HISTORY_LIST]: draft => ({
    doctorConsultationHistoryList: {
      ...draft.doctorConsultationHistoryList,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_DOCTOR_CONSULTATION_HISTORY_LIST_SUCCESS]: (draft, action) => ({
    doctorConsultationHistoryList: {
      ...draft.doctorConsultationHistoryList,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_DOCTOR_CONSULTATION_HISTORY_LIST_ERROR]: (draft, action) => ({
    doctorConsultationHistoryList: {
      ...draft.doctorConsultationHistoryList,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_DOCTOR_CONSULTATION_HISTORY_LIST_RESET]: () => ({
    doctorConsultationHistoryList: { ...initialState.doctorConsultationHistoryList },
  }),

  // ====
  [GET_DOCTOR_CONSULTATION_OVERVIEW]: draft => ({
    doctorConsultationOverview: {
      ...draft.doctorConsultationOverview,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_DOCTOR_CONSULTATION_OVERVIEW_SUCCESS]: (draft, action) => ({
    doctorConsultationOverview: {
      ...draft.doctorConsultationOverview,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_DOCTOR_CONSULTATION_OVERVIEW_ERROR]: (draft, action) => ({
    doctorConsultationOverview: {
      ...draft.doctorConsultationOverview,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_DOCTOR_CONSULTATION_OVERVIEW_RESET]: () => ({
    doctorConsultationOverview: { ...initialState.doctorConsultationOverview },
  }),

  [ASSIGN_DOC_TO_CONSULTATION]: draft => ({
    assignDocToConsultation: {
      ...draft.assignDocToConsultation,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [ASSIGN_DOC_TO_CONSULTATION_SUCCESS]: (draft, action) => ({
    assignDocToConsultation: {
      ...draft.assignDocToConsultation,
      loading: false,
      data: action.payload.data,
    },
  }),
  [ASSIGN_DOC_TO_CONSULTATION_ERROR]: (draft, action) => ({
    assignDocToConsultation: {
      ...draft.assignDocToConsultation,
      loading: false,
      error: action.payload.error,
    },
  }),
  [ASSIGN_DOC_TO_CONSULTATION_RESET]: () => ({
    assignDocToConsultation: { ...initialState.assignDocToConsultation },
  }),

  [SET_CONSULTATION_PREFERENCE]: draft => ({
    setConsultationPreference: {
      ...draft.setConsultationPreference,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [SET_CONSULTATION_PREFERENCE_SUCCESS]: (draft, action) => ({
    setConsultationPreference: {
      ...draft.setConsultationPreference,
      loading: false,
      data: action.payload.data,
    },
  }),
  [SET_CONSULTATION_PREFERENCE_ERROR]: (draft, action) => ({
    setConsultationPreference: {
      ...draft.setConsultationPreference,
      loading: false,
      error: action.payload.error,
    },
  }),
  [SET_CONSULTATION_PREFERENCE_RESET]: () => ({
    setConsultationPreference: { ...initialState.setConsultationPreference },
  }),

  [GET_PATIENT_RECORD]: draft => ({
    patientConsultationRecord: {
      ...draft.patientConsultationRecord,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_PATIENT_RECORD_SUCCESS]: (draft, action) => ({
    patientConsultationRecord: {
      ...draft.patientConsultationRecord,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_PATIENT_RECORD_ERROR]: (draft, action) => ({
    patientConsultationRecord: {
      ...draft.patientConsultationRecord,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PATIENT_RECORD_RESET]: () => ({
    patientConsultationRecord: { ...initialState.patientConsultationRecord },
  }),

  [POST_DOCTOR_NOTES]: draft => ({
    postDoctorNotesState: {
      ...draft.postDoctorNotesState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [POST_DOCTOR_NOTES_SUCCESS]: (draft, action) => ({
    postDoctorNotesState: {
      ...draft.postDoctorNotesState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_DOCTOR_NOTES_ERROR]: (draft, action) => ({
    postDoctorNotesState: {
      ...draft.postDoctorNotesState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_DOCTOR_NOTES_RESET]: () => ({
    postDoctorNotesState: { ...initialState.postDoctorNotesState },
  }),

  [POST_DOCTOR_MC]: draft => ({
    postDoctorMCState: {
      ...draft.postDoctorMCState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [POST_DOCTOR_MC_SUCCESS]: (draft, action) => ({
    postDoctorMCState: {
      ...draft.postDoctorMCState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_DOCTOR_MC_ERROR]: (draft, action) => ({
    postDoctorMCState: {
      ...draft.postDoctorMCState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_DOCTOR_MC_RESET]: () => ({
    postDoctorMCState: { ...initialState.postDoctorMCState },
  }),

  [POST_DOCTOR_REFERRAL]: draft => ({
    postDoctorReferralState: {
      ...draft.postDoctorReferralState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [POST_DOCTOR_REFERRAL_SUCCESS]: (draft, action) => ({
    postDoctorReferralState: {
      ...draft.postDoctorReferralState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_DOCTOR_REFERRAL_ERROR]: (draft, action) => ({
    postDoctorReferralState: {
      ...draft.postDoctorReferralState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_DOCTOR_REFERRAL_RESET]: () => ({
    postDoctorReferralState: { ...initialState.postDoctorReferralState },
  }),

  [END_DOCTOR_CONSULTATION]: draft => ({
    endDoctorConsultationState: {
      ...draft.endDoctorConsultationState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [END_DOCTOR_CONSULTATION_SUCCESS]: (draft, action) => ({
    endDoctorConsultationState: {
      ...draft.endDoctorConsultationState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [END_DOCTOR_CONSULTATION_ERROR]: (draft, action) => ({
    endDoctorConsultationState: {
      ...draft.endDoctorConsultationState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [END_DOCTOR_CONSULTATION_RESET]: () => ({
    endDoctorConsultationState: { ...initialState.endDoctorConsultationState },
  }),

  [SEND_AUDIO_CALL_REQUEST_BY_DOCTOR]: draft => ({
    sendAudioCallRequestByDoctorState: {
      ...draft.sendAudioCallRequestByDoctorState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_SUCCESS]: (draft, action) => ({
    sendAudioCallRequestByDoctorState: {
      ...draft.sendAudioCallRequestByDoctorState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_ERROR]: (draft, action) => ({
    sendAudioCallRequestByDoctorState: {
      ...draft.sendAudioCallRequestByDoctorState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_RESET]: () => ({
    sendAudioCallRequestByDoctorState: { ...initialState.sendAudioCallRequestByDoctorState },
  }),

  [GET_DOCTOR_TWILIO_TOKEN]: draft => ({
    getDoctorTwilioTokenState: {
      ...draft.getDoctorTwilioTokenState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_DOCTOR_TWILIO_TOKEN_SUCCESS]: (draft, action) => ({
    getDoctorTwilioTokenState: {
      ...draft.getDoctorTwilioTokenState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_DOCTOR_TWILIO_TOKEN_ERROR]: (draft, action) => ({
    getDoctorTwilioTokenState: {
      ...draft.getDoctorTwilioTokenState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_DOCTOR_TWILIO_TOKEN_RESET]: () => ({
    getDoctorTwilioTokenState: { ...initialState.getDoctorTwilioTokenState },
  }),

  [POST_DOCTOR_CONSULTATION_TIME_LAPSED]: draft => ({
    postConsultationTimeLapsedState: {
      ...draft.postConsultationTimeLapsedState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [POST_DOCTOR_CONSULTATION_TIME_LAPSED_SUCCESS]: (draft, action) => ({
    postConsultationTimeLapsedState: {
      ...draft.postConsultationTimeLapsedState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_DOCTOR_CONSULTATION_TIME_LAPSED_ERROR]: (draft, action) => ({
    postConsultationTimeLapsedState: {
      ...draft.postConsultationTimeLapsedState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_DOCTOR_CONSULTATION_TIME_LAPSED_RESET]: () => ({
    postConsultationTimeLapsedState: { ...initialState.postConsultationTimeLapsedState },
  }),

  [GET_MD_REFERRAL_NEW_LINK]: draft => ({
    getMDReferralNewLinkState: {
      ...draft.getMDReferralNewLinkState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_MD_REFERRAL_NEW_LINK_SUCCESS]: (draft, action) => ({
    getMDReferralNewLinkState: {
      ...draft.getMDReferralNewLinkState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_MD_REFERRAL_NEW_LINK_ERROR]: (draft, action) => ({
    getMDReferralNewLinkState: {
      ...draft.getMDReferralNewLinkState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_MD_REFERRAL_NEW_LINK_RESET]: () => ({
    getMDReferralNewLinkState: { ...initialState.getMDReferralNewLinkState },
  }),

  [GET_MD_MC_NEW_LINK]: draft => ({
    getMDMcNewLinkState: {
      ...draft.getMDMcNewLinkState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_MD_MC_NEW_LINK_SUCCESS]: (draft, action) => ({
    getMDMcNewLinkState: {
      ...draft.getMDMcNewLinkState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_MD_MC_NEW_LINK_ERROR]: (draft, action) => ({
    getMDMcNewLinkState: {
      ...draft.getMDMcNewLinkState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_MD_MC_NEW_LINK_RESET]: () => ({
    getMDMcNewLinkState: { ...initialState.getMDMcNewLinkState },
  }),

  [CHECK_PATIENT_CONSULTATION_STATUS]: draft => ({
    checkPatientConsultationStatusState: {
      ...draft.checkPatientConsultationStatusState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [CHECK_PATIENT_CONSULTATION_STATUS_SUCCESS]: (draft, action) => ({
    checkPatientConsultationStatusState: {
      ...draft.checkPatientConsultationStatusState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [CHECK_PATIENT_CONSULTATION_STATUS_ERROR]: (draft, action) => ({
    checkPatientConsultationStatusState: {
      ...draft.checkPatientConsultationStatusState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [CHECK_PATIENT_CONSULTATION_STATUS_RESET]: () => ({
    checkPatientConsultationStatusState: { ...initialState.checkPatientConsultationStatusState },
  }),

  [VERIFY_TRANSACTION_AMOUNT]: draft => ({
    verifyTransactionAmountState: {
      ...draft.verifyTransactionAmountState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [VERIFY_TRANSACTION_AMOUNT_SUCCESS]: (draft, action) => ({
    verifyTransactionAmountState: {
      ...draft.verifyTransactionAmountState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [VERIFY_TRANSACTION_AMOUNT_ERROR]: (draft, action) => ({
    verifyTransactionAmountState: {
      ...draft.verifyTransactionAmountState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [VERIFY_TRANSACTION_AMOUNT_RESET]: () => ({
    verifyTransactionAmountState: { ...initialState.verifyTransactionAmountState },
  }),

  [GET_PRESCRIPTION_ID]: draft => ({
    getPrescriptionIdState: {
      ...draft.getPrescriptionIdState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_PRESCRIPTION_ID_SUCCESS]: (draft, action) => ({
    getPrescriptionIdState: {
      ...draft.getPrescriptionIdState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [GET_PRESCRIPTION_ID_ERROR]: (draft, action) => ({
    getPrescriptionIdState: {
      ...draft.getPrescriptionIdState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PRESCRIPTION_ID_RESET]: () => ({
    getPrescriptionIdState: { ...initialState.getPrescriptionIdState },
  }),

  [POST_REGENERATE_AGORA_TOKEN]: draft => ({
    postRegenerateAgoraTokenState: {
      ...draft.postRegenerateAgoraTokenState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [POST_REGENERATE_AGORA_TOKEN_SUCCESS]: (draft, action) => ({
    postRegenerateAgoraTokenState: {
      ...draft.postRegenerateAgoraTokenState,
      loading: false,
      data: action.payload.data,
    },
  }),
  [POST_REGENERATE_AGORA_TOKEN_ERROR]: (draft, action) => ({
    postRegenerateAgoraTokenState: {
      ...draft.postRegenerateAgoraTokenState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [POST_REGENERATE_AGORA_TOKEN_RESET]: () => ({
    postRegenerateAgoraTokenState: { ...initialState.postRegenerateAgoraTokenState },
  }),
}, initialState)
